/* YourDent — tech layer: progress, header state, spotlight, counters, stagger */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* scroll progress + header state */
  var bar = document.querySelector('.yd-progress span');
  var header = document.querySelector('.site-header');
  var ticking = false;
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? Math.min(1, window.scrollY / h) : 0;
    if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();

  /* stagger index for grid children */
  document.querySelectorAll('.product-grid, .collection-grid, .value-props__grid, .testimonials__grid').forEach(function (grid) {
    Array.prototype.forEach.call(grid.children, function (el, i) { el.style.setProperty('--i', i % 8); });
  });

  /* pointer spotlight on cards */
  if (!reduced && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.card-product, .collection-card, .value-prop, .testimonial');
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      card.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    }, { passive: true });

    /* hero stage parallax */
    var hero = document.querySelector('[data-yd-hero]');
    var stage = hero && hero.querySelector('.yd-scan');
    if (hero && stage) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        stage.style.setProperty('--rx', (y * -6).toFixed(2) + 'deg');
        stage.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
      });
      hero.addEventListener('pointerleave', function () {
        stage.style.setProperty('--rx', '0deg');
        stage.style.setProperty('--ry', '0deg');
      });
    }
  }

  /* number counters */
  function animateCount(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^([^\d]*)([\d,]+)(.*)$/);
    if (!m || reduced) return;
    var prefix = m[1], target = parseInt(m[2].replace(/,/g, ''), 10), suffix = m[3];
    var useComma = m[2].indexOf(',') > -1;
    var start = null, dur = 1600;
    function fmt(n) { return useComma ? n.toLocaleString('en-US') : String(n); }
    function step(t) {
      if (!start) start = t;
      var k = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - k, 4);
      el.textContent = prefix + fmt(Math.round(target * eased)) + suffix;
      if (k < 1) requestAnimationFrame(step);
    }
    el.textContent = prefix + '0' + suffix;
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('[data-yd-count], .yd-stat b');
  if ('IntersectionObserver' in window && counters.length) {
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { setTimeout(function () { animateCount(en.target); }, 900); co.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { co.observe(c); });
  }

  /* mark page ready (drives entrance) */
  requestAnimationFrame(function () { root.classList.add('yd-ready'); });
})();
